import { render, staticRenderFns } from "./ProjectOrderAdd.vue?vue&type=template&id=0fdfa794&scoped=true&"
import script from "./ProjectOrderAdd.vue?vue&type=script&lang=js&"
export * from "./ProjectOrderAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOrderAdd.vue?vue&type=style&index=0&id=0fdfa794&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdfa794",
  null
  
)

export default component.exports